import { render, staticRenderFns } from "./Tabela.vue?vue&type=template&id=ecaccc0c"
import script from "./Tabela.vue?vue&type=script&lang=js"
export * from "./Tabela.vue?vue&type=script&lang=js"
import style0 from "./Tabela.vue?vue&type=style&index=0&id=ecaccc0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports